export default __webpack_public_path__ + "static/media/comingSoon.d13424b0.gif";